module.exports = __webpack_public_path__ + "static/media/logo_image_all.1455f196.png";